import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, renderSlot as _renderSlot, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-4fc262bc"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["type"];
import Loading from "@/components/Loading.vue";
import { computed } from "vue";
import { useRouter } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    props: {
        loading: { type: Boolean, default: false },
        to: null,
        variant: { default: "grey" }
    },
    setup(__props) {
        const props = __props;
        const router = useRouter();
        const onClick = (evt) => {
            if (props.to) {
                evt.preventDefault();
                router.push(props.to);
            }
        };
        const className = computed(() => ["button", props.variant ? `button-${props.variant}` : undefined]
            .filter((cl) => cl !== undefined)
            .join(" "));
        return (_ctx, _cache) => {
            return (_ctx.$attrs.type in ['button', 'submit'])
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    onClick: onClick,
                    class: _normalizeClass(_unref(className)),
                    type: _ctx.$attrs.type
                }, null, 10, _hoisted_1))
                : (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    onClick: onClick,
                    class: _normalizeClass(_unref(className))
                }, [
                    (props.loading)
                        ? (_openBlock(), _createBlock(Loading, {
                            key: 0,
                            class: "icon h-7 w-7"
                        }))
                        : _renderSlot(_ctx.$slots, "default", { key: 1 })
                ], 2));
        };
    }
});
